import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "panel-result" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h5", { style: {"margin":"16px 0 5px 0"} }, "Пакеты", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CatalogueGrid = _resolveComponent("CatalogueGrid")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode(_component_CatalogueGrid, {
      summaryConfig: _ctx.summaryConfig,
      controller: 'PlanPackageResult',
      customLoadUrl: "GetRollupData",
      columns: _ctx.columns,
      filterRowVisible: !_ctx.selectMode,
      groupPanelVisible: false,
      headerFilterVisible: !_ctx.selectMode,
      filterPanelVisible: false,
      showPageSizeSelector: !_ctx.selectMode,
      pageSize: 10,
      pageSizes: _ctx.pageSizes,
      editingConfig: _ctx.editingConfig,
      selectionConfig: _ctx.selectionConfig,
      designConfig: _ctx.designConfig,
      getSelectedData: _ctx.getSelectedData,
      changeSelectedData: _ctx.changeSelectedData,
      parentModel: _ctx.parentModel,
      selectMode: _ctx.selectMode,
      toolbarItems: _ctx.toolbarItems,
      onRowPrepared: _ctx.onRowPrepared
    }, null, 8, ["summaryConfig", "columns", "filterRowVisible", "headerFilterVisible", "showPageSizeSelector", "pageSizes", "editingConfig", "selectionConfig", "designConfig", "getSelectedData", "changeSelectedData", "parentModel", "selectMode", "toolbarItems", "onRowPrepared"])
  ]))
}